export enum enteteTableauListeCRNREnum {
	compte = 'Compte',
	compteRecuperable = 'Compte récupérable',
	compteNonRecuperable = 'Compte non récupérable',
	rubriqueAnalytique = 'Rubrique analytique'
}